export default {
    TOGGLE_SIDEBAR(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    SET_SELECTED_MODULE(state, module) {
      state.selectedModule = module;
    },
  };